// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1k00Y","title":"Info_title__3KxHU","selects":"Info_selects__34n14","requiredAsterisk":"Info_requiredAsterisk__1q0Iw"};